@if (isNotEmpty()) {
  <mat-table [dataSource]="products()" style="min-width: 720px">
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef class="name-column">
        {{ 'name' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="name-column">
        <ng-container *ngTemplateOutlet="productNameCell; context: { $implicit: element }" />
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="alreadyOrdered">
      <mat-header-cell *matHeaderCellDef class="already-ordered-column">
        {{ 'alreadyOrdered' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element" class="already-ordered-column-cell">
        {{ element.totalOrdered | agrNumber: '1.0-2' }} {{ 'unit.' + element.unitOfMeasurement | translate }}
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns" />
    <mat-row *matRowDef="let row; columns: displayedColumns" />
  </mat-table>
} @else {
  <agr-notification-empty />
}

<ng-template #productNameCell let-element>
  <div>
    <h4>{{ element.name }}</h4>
    @for (cropField of element.cropFields; track cropField.id) {
      <div class="crop-field-row">
        <p>
          <span>{{ cropField.name }} </span>
          <span>({{ cropField.hectares | agrNumber: '1.0-2' }} {{ 'unit.HAR' | translate }}) - </span>
          <span>{{ cropField.cropVariety }}</span>
        </p>
        <p class="text--gray">
          <span>{{ 'order' | translate }} </span>
          <span>{{ cropField.orderNumber }}, </span>
          <span>{{ cropField.orderDate | date }}</span>
        </p>
      </div>
    }
  </div>
</ng-template>
